import clsx from 'clsx';
import { CSSProperties, JSX } from 'react';

import { toRem } from '../../utils/ui';

import './divider.scss';

export const Divider = (props: DividerProps) => {
  const { as: Component = 'div', className, orientation = 'vertical', size = '100%' } = props;

  return (
    <Component
      className={clsx('divider', className, `o-${orientation}`)}
      style={
        {
          ['--size']: toRem(size),
        } as CSSProperties
      }
    />
  );
};

interface DividerProps {
  className?: string;
  size?: number | string;
  as?: keyof JSX.IntrinsicElements;
  orientation?: 'horizontal' | 'vertical';
}
